import React, { useState, useEffect, useRef } from "react";

const PeriodSection: React.FC = () => {
  const years = [1995, 2000, 2005, 2010, 2017, 2018, 2020, 2024, 2025];
  const [activeYear, setActiveYear] = useState(years[0]);
  const sectionRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const observedYear = Number(entry.target.getAttribute("data-year"));
            setActiveYear(observedYear);
          }
        });
      },
      { threshold: 0.6 } // Adjust threshold for better visibility detection
    );

    const elements = document.querySelectorAll(".year-item");
    elements.forEach((el) => observer.observe(el));

    return () => {
      elements.forEach((el) => observer.unobserve(el));
    };
  }, []);

  // Handle dot click
  const handleDotClick = (year: number) => {
    setActiveYear(year);
    const targetElement = document.querySelector(`[data-year="${year}"]`);
    if (targetElement) {
      targetElement.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  };

  return (
    <div
      ref={sectionRef}
      className="w-full h-screen flex bg-cover bg-center bg-no-repeat justify-center items-center relative overflow-hidden"
      style={{ backgroundImage: "url('/assets/image/company_period.png')" }}
    >
      <div className="relative flex flex-row w-full max-w-[1227px] p-4 lg:p-0 items-center">
        <div className="flex flex-col items-end pr-6 ml-10 lg:ml-28 z-20 h-full space-y-8">
          {years.map((year) => (
            <div
              key={year}
              data-year={year}
              className={`year-item font-normal ${
                year === activeYear
                  ? "text-red-700 font-semibold text-5xl md:text-7xl animate-blink"
                  : "text-white text-3xl md:text-4xl"
              }`}
            >
              {year}
            </div>
          ))}
        </div>

        <div className="relative flex flex-col items-center w-[50px] md:w-[100px]">
          <div className="absolute left-1/2 transform -translate-x-1/2 border-l-2 border-white h-full z-10"></div>
          <div className="flex flex-col items-center space-y-14 md:space-y-14 z-20">
            {years.map((year) => (
              <div key={year} className="relative flex items-center">
                <div
                  className={`w-4 h-4 md:w-6 md:h-6 rounded-full border-1 border-white z-10 transition-all duration-500 cursor-pointer ${
                    year === activeYear ? "bg-[#D9D9D9]" : "bg-[#A0A0A0]"
                  }`}
                  onClick={() => handleDotClick(year)}
                ></div>
              </div>
            ))}
          </div>
        </div>

        <div className="ml-6 md:ml-10 text-white text-sm md:text-lg lg:text-xl font-medium leading-loose w-[600px] z-20 transition-all duration-1000">
          {activeYear === 1995 && (
            <p>
              Business Establishment Siskon Hydraulics was founded, marking the
              beginning of our journey in the hydraulic industry.
            </p>
          )}
          {activeYear === 2000 && (
            <p>
              First Major Hydraulic System Deployment Successfully designed and
              installed a large-scale hydraulic power unit for a Tire
              manufacturer, setting a benchmark for future projects.
            </p>
          )}
          {activeYear === 2005 && (
            <p>
              Expansion into Hydraulic Pump & Motor Servicing Introduced
              specialized services for repairing and maintaining hydraulic pumps
              and motors, enhancing customer support. Also acquired 150 sq. m.
              site in Vatva Gujarat.
            </p>
          )}
          {activeYear === 2010 && (
            <p>
              Advanced Filtration & Oil Monitoring Solutions Integrated oil
              monitoring systems from Parker Hydraulics, ensuring improved
              reliability and reduced failures in hydraulic systems.
            </p>
          )}
          {activeYear === 2017 && <p>Established Siskon Ventures Pvt. Ltd.</p>}
          {activeYear === 2018 && (
            <p>
              Collaboration with Mining Industry OEM Partnered with leading
              manufacturers to provide customized hydraulic solutions for
              large-scale mining application.
            </p>
          )}
          {activeYear === 2020 && (
            <p>
              Development of High-Performance Power Units Designed and tested
              next-generation hydraulic power units, improving energy efficiency
              and system performance.
            </p>
          )}
          {activeYear === 2024 && (
            <p>
              Factory Expansion to 300 sq meters Expanded our facility to 300 sq
              meters, dedicating space for assembly, servicing, and testing of
              hydraulic power units.
            </p>
          )}
          {activeYear === 2025 && (
            <p>
              30 Years of Excellence in Hydraulics Celebrating three decades of
              delivering top-quality hydraulic solutions, innovation, and
              customer satisfaction.
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default PeriodSection;